import {
  isEmptyString,
  notEmptyString,
} from '@populateui/utils';
import {
  PhoneNumberDTO,
} from 'dtos/phoneNumberDTO';
import {
  TelehealthProviderJoinInfoDTO,
} from 'dtos/telehealthProviderJoinInfoDTO';
import isNil from 'lodash/isNil';

export const telehealthVisitScheduledTooltip = 'Telehealth visit - video call will be scheduled';
export const telehealthProviderNotConfiguredTooltip = 'Contact Populate support to enable video consultations for this provider.';

export function hasTelehealthMeeting(
  telehealthProviderJoinInfo?: TelehealthProviderJoinInfoDTO,
): boolean {
  return !isEmptyString(telehealthProviderJoinInfo?.startUrl ?? '');
}

export function getPatientPhoneNumber(
  phoneNumber?: string | PhoneNumberDTO | null,
): string {
  if (isNil(phoneNumber)) {
    return '';
  }

  if (typeof phoneNumber === 'string') {
    return isEmptyString(phoneNumber) ? '' : phoneNumber;
  }

  return phoneNumber.phoneNumberWithAreaCode ?? '';
}

type TelehealthPatientContact = {
  phoneNumber?: string | PhoneNumberDTO | null;
  email?: string | null;
};

export function hasTelehealthPatientContact(
  patient?: TelehealthPatientContact | null,
): boolean {
  if (isNil(patient)) {
    return false;
  }

  const phoneNumber = getPatientPhoneNumber(patient.phoneNumber);
  const email = patient.email ?? '';

  return notEmptyString(phoneNumber) || notEmptyString(email);
}
